<template>
	<div class="container-fluid content">
    <div class="row">
      <div class="col-md-4 col-md-offset-4">

          <h4><span>{{ $t('Registro') }}</span></h4>
          <p class="center">
            {{ $t('La página web www.tatarana.net es un servicio exclusivo para bibliotecas y/o centros de documentación') }}
          </p>
          
          <form method="post" v-on:submit.prevent="onSubmit">
            <div class="form-head fix">
              <div class="input-group">
                <div class="input-group-addon"><i class="fa fa-institution"></i></div>
                  <input type="text" class="form-control" :placeholder="$t('Nombre de la biblioteca')" maxlength="150" required="" autofocus v-model="biblioteca.nombre">
              </div>
              <div class="input-group">
                <div class="input-group-addon"><i class="fa fa-book"></i></div>
                  <input type="text" class="form-control" :placeholder="$t('Nombre del catálogo')" maxlength="150" v-model="biblioteca.catalogo">
              </div>
              <div class="input-group">
                <div class="input-group-addon"><i class="fa fa-map-marker"></i></div>
                  <input type="text" class="form-control" :placeholder="$t('Dirección')" maxlength="150" required="" v-model="biblioteca.direccion">
              </div>
              <div class="input-group">
                <div class="input-group-addon"><i class="fa fa-building-o"></i></div>
                  <input type="text" class="form-control" :placeholder="$t('Población')" maxlength="150" required="" v-model="biblioteca.poblacion">
              </div>
              <div class="input-group">
                <div class="input-group-addon"><i class="fa fa-building-o"></i></div>
                  <input type="text" class="form-control" :placeholder="$t('Provincia')" maxlength="150" required="" v-model="biblioteca.provincia">
              </div>
              <div class="input-group widthPer50">
                <div class="input-group-addon"><i class="fa fa-envelope-o"></i></div>
                  <input type="text" class="form-control" :placeholder="$t('Código postal')" maxlength="150" required="" v-model="biblioteca.codigo_postal">
              </div>
              <div class="input-group">
                <div class="input-group-addon"><i class="fa fa-at"></i></div>
                  <input type="email" class="form-control" :placeholder="$t('Email')" maxlength="150" required="" v-model="biblioteca.email">
              </div>
              <div class="input-group">
                <div class="input-group-addon"><i class="fa fa-phone"></i></div>
                  <input type="number" class="form-control" :placeholder="$t('Teléfono')" maxlength="150" required="" v-model="biblioteca.telefono">
              </div>

              <br>
              <h5><span>{{ $t('Datos de acceso') }}</span></h5>
              <div class="input-group">
                <div class="input-group-addon"><i class="fa fa-user"></i></div>
                  <input type="text" class="form-control" :placeholder="$t('Nombre de usuario')" maxlength="150" required="" v-model="biblioteca.usuario" pattern=".{5,}" title="Longitud mínima 5">
              </div>
              <div class="input-group">
                <div class="input-group-addon"><i class="fa fa-lock"></i></div>
                  <input type="password" class="form-control" :placeholder="$t('Contraseña')" maxlength="150" required="" v-model="biblioteca.contrasena" pattern=".{8,}" title="La contraseña debe tener una longitud mínima de 8 caracteres" autocomplete="on">
              </div>
              <div class="input-group">
                <div class="input-group-addon"><i class="fa fa-lock"></i></div>
                  <input type="password" class="form-control" :placeholder="$t('Repetir contraseña')" maxlength="150" required="" v-model="biblioteca.contrasena_confirmacion" autocomplete="on">
              </div>              
              <div class=""> 
                <input type="checkbox" aria-label="..." v-model="condicionesDeUso" required=""> {{ $t('Acepto la') }} 
                <router-link :to="{ name: 'politica',  params: { language: getLocale} }">{{ $t('política de datos') }}</router-link> {{ $t('y las') }} <router-link :to="{ name: 'uso',  params: { language: getLocale} }">{{ $t('condiciones de uso') }}</router-link> de www.tatarana.net
              </div>
            </div>

            <div v-if="loading" class="loading center"><img src="@/assets/img/loading.gif" alt=""></div>

            <div v-if="frm_success" class="frm-success">{{ frm_success_message }}</div>
            <div v-if="frm_error" class="frm-error">{{ frm_error_message }}</div>

            <div class="center">
              <button class="btn btn-tata mb40" type="submit" :disabled="loading">{{ $t('Registrarme') }} <i class="fa fa-angle-double-right"></i></button>
            </div>
          </form>

      </div>

      <div class="col-md-4">
        <!-- <pre>{{ $data }}</pre> -->
      </div>

    </div>
  </div>
</template>

<i18n>
{
  "es": {
    "Registro": "Registro",
    "La página web www.tatarana.net es un servicio exclusivo para bibliotecas y/o centros de documentación": "La página web www.tatarana.net es un servicio exclusivo para bibliotecas y/o centros de documentación",
    "Nombre de la biblioteca": "Nombre de la biblioteca",
    "Nombre de usuario": "Nombre de usuario",
    "Nombre del catálogo": "Nombre del catálogo",
    "Dirección": "Dirección",
    "Población": "Población",
    "Provincia": "Provincia",
    "Código postal": "Código postal",
    "Email / nombre de usuario": "Email / nombre de usuario",
    "Email": "Email",
    "Teléfono": "Teléfono",
    "Contraseña": "Contraseña",
    "Repetir contraseña": "Repetir contraseña",
    "Registrarme": "Registrarme",
    "La contraseña debe tener una longitud mínima de 8 caracteres!": "La contraseña debe tener una longitud mínima de 8 caracteres!",
    "Datos de acceso": "Datos de acceso",
    "Acepto la": "Acepto la",
    "política de datos": "política de datos",
    "y las": "y las",
    "condiciones de uso": "condiciones de uso",
    "": ""
  },
  "en": {
  },
  "ca": {
    "Registro": "Registre",
    "La página web www.tatarana.net es un servicio exclusivo para bibliotecas y/o centros de documentación": "La página web www.tatarana.net és un servei exclusiu per biblioteques i/o centres de documentació",
    "Nombre de la biblioteca": "Nom de la biblioteca",
    "Nombre de usuario": "Nom d’usuari",
    "Nombre del catálogo": "Nom del catàleg",
    "Dirección": "Direcció",
    "Población": "Població",
    "Provincia": "Província",
    "Código postal": "Codi postal",
    "Email / nombre de usuario": "Email / nom d’usuari",
    "Email": "Email",
    "Teléfono": "Telèfon",
    "Contraseña": "Contrasenya",
    "Repetir contraseña": "Repetir contrasenya",
    "Registrarme": "Registrar-me",
    "La contraseña debe tener una longitud mínima de 8 caracteres!": "La contrasenya ha de tenir com a mínim 8 caràcters!",
    "Datos de acceso": "Dades d’accés",
    "Acepto la": "Estic d'acord amb la",
    "política de datos": "política de dades",
    "y las": "i les",
    "condiciones de uso": "condicions d'ús",
    "": ""
  }
}
</i18n>

<script>
  import axios from 'axios'; 
  import { mapGetters } from 'vuex';

	export default {
		data: () => {
			return{
        biblioteca: {
          nombre: '',
          usuario: '',
          catalogo: '',
          direccion: '',
          poblacion: '',
          provincia: '',
          codigo_postal: '',
          telefono: '',
          email: '',
          contrasena: '',
          contrasena_confirmacion: ''
        },
        
        condicionesDeUso: false,
        frm_response: '',
        frm_success: false,
        frm_success_message: '',
        frm_error: false,
        frm_error_message: '',
        loading: false
			}
		},
    computed: mapGetters(['getApiUrl', 'getLocale']), 
    methods: {
      validateEmail(){
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(this.biblioteca.email);
      },
      onSubmit(){
        if( !this.validateEmail() ){
          this.frm_error_message = this.$t('Formato de email incorrecto');
          this.frm_error = true;
        }else if( this.biblioteca.contrasena.length < 8 ){
          this.frm_error_message = this.$t('La contraseña debe tener una longitud mínima de 8 caracteres!');
          this.frm_error = true;
        }else if( this.biblioteca.contrasena != this.biblioteca.contrasena_confirmacion ){
          this.frm_error_message = this.$t('La contraseña nueva y la confirmación no coinciden!');
          this.frm_error = true;
        }else{
          this.frm_success = false;
          this.frm_error = false;
          this.showLoading();

          axios.post(this.getApiUrl + this.getLocale + '/register', {
            data: this.biblioteca
          })
          .then( (response) => {
            this.hideLoading();
            this.frm_success_message = response.data.msg;
            this.frm_success = true;   
            this.clearFormData();              
          })
          .catch( (error) => {
            this.frm_error_message = error.response.data.status + ' ' + error.response.data.msg;
            this.frm_error = true;
            this.hideLoading();
          });
        }
      },
      showLoading(){ this.loading = true; },
      hideLoading(){ this.loading = false; },
      clearFormData(){
        this.biblioteca = [];
        this.condicionesDeUso = false;
      }
    }
  }
</script>
